// Auto-generated by backend/generate_manasik_reminders.py — Manasik schedule reminders (11 languages).
export const REMINDER_DAYS = [
  {
    "day": 8,
    "title": {
      "id": "8 Dzulhijjah — Hari Tarwiyah",
      "en": "8 Dhul Hijjah — The Day of Tarwiyah",
      "ar": "٨ ذو الحجة — يوم التروية",
      "fr": "8 Dhul Hijja — Le Jour de Tarwiyah",
      "de": "8. Dhul Hijjah — Der Tag der Tarwiyah",
      "es": "8 Dhul Hiyya — El Día de Tarwiyah",
      "ru": "8 Зуль-Хиджа — День Тарвийа",
      "zh": "12月8日 — 塔尔维亚日",
      "ja": "ズルヒッジャ月8日 — タルウィーヤの日",
      "ko": "줄히자 8일 — 타르위야의 날",
      "hi": "8 ज़ुलहिज्जा — तर्विया का दिन"
    },
    "body": {
      "id": "Niat ihram haji dari penginapan, berangkat ke Mina, mabit di Mina dan perbanyak talbiyah.",
      "en": "Make the intention (niat) for Hajj Ihram from the lodging, depart to Mina, stay overnight (mabit) in Mina, and recite the Talbiyah frequently.",
      "ar": "انوِ الإحرام بالحج من مقر إقامتك، ثم انطلق إلى منى، وبِتْ في منى، وأكثِر من التلبية.",
      "fr": "Formuler l'intention du Ihram pour le Hajj depuis le logement, partir à Mina, passer la nuit (mabit) à Mina et réciter fréquemment la Talbiyah.",
      "de": "Die Absicht (Niat) für den Hajj-Ihram vom Quartier aus fassen, nach Mina aufbrechen, in Mina übernachten (Mabit) und die Talbiyah häufig rezitieren.",
      "es": "Hacer la intención (niat) del Ihram del Hajj desde el alojamiento, partir hacia Mina, pernoctar (mabit) en Mina y recitar la Talbiyah con frecuencia.",
      "ru": "Совершите намерение (ният) Ихрама Хаджа из места проживания, отправляйтесь в Мину, проведите ночь (мабит) в Мине и почаще читайте Талбию.",
      "zh": "在住所起念（niat）朝觐戒衣（Ihram），前往米纳，在米纳过夜（mabit），并多念泰勒比亚（Talbiyah）。",
      "ja": "宿泊地からハッジのイフラームの意図（ニヤット）を立て、ミナーへ出発し、ミナーで夜を過ごし（マビット）、タルビヤを多く唱える。",
      "ko": "숙소에서 하지 이흐람의 니야트(niat)를 하고, 미나로 출발하여 미나에서 마비트(mabit)하며, 탈비야를 자주 암송한다.",
      "hi": "ठहरने की जगह से हज के इहराम की नीयत करें, मिना के लिए रवाना हों, मिना में मबीत (रात बिताएं) करें और तलबियह अधिक पढ़ें।"
    }
  },
  {
    "day": 9,
    "title": {
      "id": "9 Dzulhijjah — Wukuf di Arafah",
      "en": "9 Dhul Hijjah — Wuquf at Arafah",
      "ar": "٩ ذو الحجة — الوقوف بعرفة",
      "fr": "9 Dhul Hijja — Le Wuquf à Arafah",
      "de": "9. Dhul Hijjah — Wuquf in Arafah",
      "es": "9 Dhul Hiyya — El Wuquf en Arafah",
      "ru": "9 Зуль-Хиджа — Вукуф на Арафате",
      "zh": "12月9日 — 在阿拉法特山站立（Wuquf）",
      "ja": "ズルヒッジャ月9日 — アラファートでのウクーフ",
      "ko": "줄히자 9일 — 아라파에서의 우쿠프",
      "hi": "9 ज़ुलहिज्जा — अरफ़ात में वुक़ूफ़"
    },
    "body": {
      "id": "Wukuf setelah Dzuhur hingga Maghrib: perbanyak doa, zikir dan istighfar. Malamnya mabit di Muzdalifah.",
      "en": "Perform Wuquf from after Dhuhr until Maghrib: engage abundantly in supplication (du'a), dhikr, and istighfar. That night, stay overnight (mabit) in Muzdalifah.",
      "ar": "قِفْ بعرفة من بعد الظهر حتى المغرب، وأكثِر من الدعاء والذكر والاستغفار. وبِتْ تلك الليلة في مزدلفة.",
      "fr": "Accomplir le Wuquf après le Dhuhr jusqu'au Maghrib : se consacrer abondamment à la supplication (du'a), au dhikr et à l'istighfar. Cette nuit-là, passer la nuit (mabit) à Muzdalifah.",
      "de": "Das Wuquf nach dem Dhuhr bis zum Maghrib verrichten: reichlich Bittgebet (Du'a), Dhikr und Istighfar sprechen. In jener Nacht in Muzdalifah übernachten (Mabit).",
      "es": "Realizar el Wuquf desde después del Dhuhr hasta el Maghrib: dedicarse abundantemente a la súplica (du'a), el dhikr y el istighfar. Esa noche, pernoctar (mabit) en Muzdalifah.",
      "ru": "Совершите Вукуф с момента после Зухра до Магриба: усердно занимайтесь мольбой (ду'а), зикром и истигфаром. В ту ночь проведите мабит в Муздалифе.",
      "zh": "在晌礼后至昏礼期间进行站立（Wuquf）：大量祈祷（du'a）、念兹克尔（dhikr）和求恕（istighfar）。当晚在穆兹德利法过夜（mabit）。",
      "ja": "ズフルの後からマグリブまでウクーフを行い、ドゥアー、ズィクル、イスティグファールを多く行う。その夜はムズダリファでマビットする。",
      "ko": "주흐르 이후부터 마그립까지 우쿠프를 수행하며 두아, 지크르, 이스티그파르를 많이 한다. 그날 밤 무즈달리파에서 마비트한다.",
      "hi": "ज़ुहर के बाद मग़रिब तक वुक़ूफ़ करें: दुआ, ज़िक्र और इस्तिग़फ़ार अधिक करें। उस रात मुज़्दलिफ़ा में मबीत करें।"
    }
  },
  {
    "day": 10,
    "title": {
      "id": "10 Dzulhijjah — Hari Nahr",
      "en": "10 Dhul Hijjah — The Day of Nahr",
      "ar": "١٠ ذو الحجة — يوم النحر",
      "fr": "10 Dhul Hijja — Le Jour de Nahr",
      "de": "10. Dhul Hijjah — Der Tag des Nahr",
      "es": "10 Dhul Hiyya — El Día de Nahr",
      "ru": "10 Зуль-Хиджа — День Нахр",
      "zh": "12月10日 — 宰牲日（Nahr）",
      "ja": "ズルヒッジャ月10日 — ナフルの日",
      "ko": "줄히자 10일 — 나흐르의 날",
      "hi": "10 ज़ुलहिज्जा — नह्र का दिन"
    },
    "body": {
      "id": "Lempar Jumrah Aqabah, hadyu (kurban), tahallul awal, lalu Tawaf Ifadah dan Sa'i.",
      "en": "Throw the pebbles at Jumrah Aqabah, perform the hadyu (sacrifice), do the first Tahallul, then perform Tawaf Ifadah and Sa'i.",
      "ar": "ارمِ جمرة العقبة، ثم اذبح الهدي، ثم تحلَّل التحلل الأول، ثم طُفْ طواف الإفاضة وسعَ السعي.",
      "fr": "Lancer les cailloux à la Jumrah Aqabah, effectuer le hadyu (sacrifice), faire le premier Tahallul, puis accomplir le Tawaf Ifadah et le Sa'i.",
      "de": "Die Steinchen an der Jumrah Aqabah werfen, das Hadyu (Opfertier) schlachten, die erste Tahallul vollziehen, dann Tawaf Ifadah und Sa'i durchführen.",
      "es": "Lanzar las piedras en Jumrah Aqabah, realizar el hadyu (sacrificio), efectuar el primer Tahallul, luego realizar el Tawaf Ifadah y el Sa'i.",
      "ru": "Бросьте камешки в Джамрат Акаба, совершите жертвоприношение (хадью), выполните первый Тахаллул, затем совершите Таваф Ифада и Са'й.",
      "zh": "投掷阿卡巴石柱（Jumrah Aqabah），宰牲（hadyu），进行初次解禁（Tahallul Awal），然后进行告别圣殿绕行（Tawaf Ifadah）和奔走（Sa'i）。",
      "ja": "ジャムラット・アカバに石を投げ、ハドユ（供犠）を行い、最初のタハッルルをし、その後タワーフ・イファーダとサアイを行う。",
      "ko": "잠라툴 아카바에 돌을 던지고, 하드유(희생제사)를 드리고, 첫 번째 타할룰을 행한 후, 타와프 이파다와 사이를 수행한다.",
      "hi": "जमरतुल अक़बह पर कंकरी मारें, हद्यु (क़ुर्बानी) करें, पहला तहल्लुल करें, फिर तवाफ़ इफ़ाज़ह और सई करें।"
    }
  },
  {
    "day": 11,
    "title": {
      "id": "11 Dzulhijjah — Hari Tasyrik",
      "en": "11 Dhul Hijjah — Tashreeq Day",
      "ar": "١١ ذو الحجة — أيام التشريق",
      "fr": "11 Dhul Hijja — Jour du Tashreeq",
      "de": "11. Dhul Hijja — Tashreeq-Tag",
      "es": "11 Dhul Hijja — Día de Tashreeq",
      "ru": "11 Зуль-Хиджа — День Ташрик",
      "zh": "12月11日 — 塔什里格日",
      "ja": "ズルヒッジャ月11日 — タシュリーク日",
      "ko": "줄히자 11일 — 타슈리크의 날",
      "hi": "11 ज़ुल-हिज्जा — तश्रीक़ दिवस"
    },
    "body": {
      "id": "Mabit di Mina; lempar tiga jumrah (Ula, Wustha, Aqabah) setelah Dzuhur.",
      "en": "Stay overnight (Mabit) in Mina; stone the three Jamarat (Ula, Wustha, Aqabah) after Dhuhr.",
      "ar": "المبيت في منى؛ رمي الجمرات الثلاث (الأولى، الوسطى، العقبة) بعد صلاة الظهر.",
      "fr": "Passer la nuit (Mabit) à Mina ; lapider les trois Jamarat (Ula, Wustha, Aqabah) après Dhuhr.",
      "de": "Übernachtung (Mabit) in Mina; Steinigung der drei Jamarat (Ula, Wustha, Aqabah) nach dem Dhuhr-Gebet.",
      "es": "Pernoctar (Mabit) en Mina; apedrear las tres Jamarat (Ula, Wustha, Aqabah) después del Dhuhr.",
      "ru": "Ночёвка (Мабит) в Мине; бросание камней в три Джамарат (Уля, Вуста, Акаба) после Зухра.",
      "zh": "在米纳过夜（Mabit）；祖尔礼拜后投掷三处石柱（乌拉、乌斯塔、阿卡巴）。",
      "ja": "ミナーで夜を過ごし（マビート）、ズフル礼拝後に三つのジャマラート（ウーラー、ウスター、アカバ）に投石する。",
      "ko": "미나에서 마비트(숙박); 주흐르 이후 세 자마라트(울라, 우스타, 아카바)에 투석.",
      "hi": "मिना में मबीत (रात्रि विश्राम); ज़ुहर के बाद तीनों जमरात (उला, वुस्ता, अक़बा) पर कंकरी मारना।"
    }
  },
  {
    "day": 12,
    "title": {
      "id": "12 Dzulhijjah — Hari Tasyrik",
      "en": "12 Dhul Hijjah — Tashreeq Day",
      "ar": "١٢ ذو الحجة — أيام التشريق",
      "fr": "12 Dhul Hijja — Jour du Tashreeq",
      "de": "12. Dhul Hijja — Tashreeq-Tag",
      "es": "12 Dhul Hijja — Día de Tashreeq",
      "ru": "12 Зуль-Хиджа — День Ташрик",
      "zh": "12月12日 — 塔什里格日",
      "ja": "ズルヒッジャ月12日 — タシュリーク日",
      "ko": "줄히자 12일 — 타슈리크의 날",
      "hi": "12 ज़ुल-हिज्जा — तश्रीक़ दिवस"
    },
    "body": {
      "id": "Lempar tiga jumrah setelah Dzuhur. Nafar awal: boleh meninggalkan Mina sebelum Maghrib.",
      "en": "Stone the three Jamarat after Dhuhr. Nafar Awwal: permitted to leave Mina before Maghrib.",
      "ar": "رمي الجمرات الثلاث بعد صلاة الظهر. النفر الأول: يجوز مغادرة منى قبل صلاة المغرب.",
      "fr": "Lapider les trois Jamarat après Dhuhr. Nafar Awwal : il est permis de quitter Mina avant le Maghrib.",
      "de": "Steinigung der drei Jamarat nach dem Dhuhr-Gebet. Nafar Awwal: Erlaubt, Mina vor dem Maghrib zu verlassen.",
      "es": "Apedrear las tres Jamarat después del Dhuhr. Nafar Awwal: está permitido salir de Mina antes del Maghrib.",
      "ru": "Бросание камней в три Джамарат после Зухра. Нафар Авваль: разрешено покинуть Мину до Магриба.",
      "zh": "祖尔礼拜后投掷三处石柱。纳法尔·奥瓦尔：可在马格里布前离开米纳。",
      "ja": "ズフル礼拝後に三つのジャマラートに投石する。ナファル・アッワル：マグリブ前にミナーを離れることが許される。",
      "ko": "주흐르 이후 세 자마라트에 투석. 나파르 아왈: 마그립 전에 미나를 떠나는 것이 허용됨.",
      "hi": "ज़ुहर के बाद तीनों जमरात पर कंकरी मारना। नफ़र अव्वल: मग़रिब से पहले मिना छोड़ना जायज़ है।"
    }
  },
  {
    "day": 13,
    "title": {
      "id": "13 Dzulhijjah — Nafar Tsani",
      "en": "13 Dhul Hijjah — Nafar Tsani",
      "ar": "١٣ ذو الحجة — النفر الثاني",
      "fr": "13 Dhul Hijja — Nafar Tsani",
      "de": "13. Dhul Hijja — Nafar Tsani",
      "es": "13 Dhul Hijja — Nafar Tsani",
      "ru": "13 Зуль-Хиджа — Нафар Сани",
      "zh": "12月13日 — 纳法尔·萨尼",
      "ja": "ズルヒッジャ月13日 — ナファル・サーニー",
      "ko": "줄히자 13일 — 나파르 사니",
      "hi": "13 ज़ुल-हिज्जा — नफ़र सानी"
    },
    "body": {
      "id": "Lempar tiga jumrah setelah Dzuhur lalu meninggalkan Mina. Jangan lupa Tawaf Wada sebelum pulang.",
      "en": "Stone the three Jamarat after Dhuhr, then depart from Mina. Do not forget Tawaf Wada' before returning home.",
      "ar": "رمي الجمرات الثلاث بعد صلاة الظهر ثم مغادرة منى. لا تنسَ طواف الوداع قبل العودة.",
      "fr": "Lapider les trois Jamarat après Dhuhr, puis quitter Mina. N'oubliez pas le Tawaf Wada avant de rentrer.",
      "de": "Steinigung der drei Jamarat nach dem Dhuhr-Gebet, dann Mina verlassen. Vergessen Sie nicht den Tawaf Wada' vor der Abreise.",
      "es": "Apedrear las tres Jamarat después del Dhuhr, luego partir de Mina. No olvides el Tawaf Wada' antes de regresar.",
      "ru": "Бросание камней в три Джамарат после Зухра, затем отъезд из Мины. Не забудьте Таваф Вада' перед возвращением домой.",
      "zh": "祖尔礼拜后投掷三处石柱，然后离开米纳。返程前不要忘记告别塔瓦夫（Tawaf Wada）。",
      "ja": "ズフル礼拝後に三つのジャマラートに投石し、その後ミナーを出発する。帰国前にタワーフ・ワダーを忘れずに行うこと。",
      "ko": "주흐르 이후 세 자마라트에 투석 후 미나를 출발. 귀국 전 타와프 와다를 잊지 말 것.",
      "hi": "ज़ुहर के बाद तीनों जमरात पर कंकरी मारें, फिर मिना से रवाना हों। वापसी से पहले तवाफ़ वदा' करना न भूलें।"
    }
  }
];

export const REMINDER_UI = {
  "cardTitle": {
    "id": "Pengingat Jadwal Manasik",
    "en": "Manasik Schedule Reminder",
    "ar": "تذكير بجدول مناسك الحج والعمرة",
    "fr": "Rappel du calendrier des manasik",
    "de": "Erinnerung an den Manasik-Zeitplan",
    "es": "Recordatorio del calendario de manasik",
    "ru": "Напоминание о расписании манасик",
    "zh": "朝觐功课日程提醒",
    "ja": "マナースィクスケジュールリマインダー",
    "ko": "마나시크 일정 알림",
    "hi": "मनासिक कार्यक्रम अनुस्मारक"
  },
  "cardHint": {
    "id": "Notifikasi amalan penting setiap hari 8–13 Dzulhijjah: malam sebelumnya (19.30 waktu Makkah) dan pagi hari-H (05.30 waktu Makkah).",
    "en": "Notifications for important rituals each day from 8–13 Dhul-Hijjah: the night before (19:30 Makkah time) and the morning of the day itself (05:30 Makkah time).",
    "ar": "إشعارات بالمناسك المهمة كل يوم من 8 إلى 13 ذي الحجة: ليلة اليوم السابق (19:30 بتوقيت مكة المكرمة) وصباح اليوم ذاته (05:30 بتوقيت مكة المكرمة).",
    "fr": "Notifications pour les rites importants chaque jour du 8 au 13 Dhul-Hijja : la veille au soir (19h30, heure de La Mecque) et le matin du jour J (05h30, heure de La Mecque).",
    "de": "Benachrichtigungen für wichtige Rituale täglich vom 8.–13. Dhul-Hijja: am Vorabend (19:30 Uhr Mekka-Zeit) und am Morgen des jeweiligen Tages (05:30 Uhr Mekka-Zeit).",
    "es": "Notificaciones de los ritos importantes cada día del 8 al 13 de Dhul-Hijja: la noche anterior (19:30, hora de La Meca) y la mañana del día correspondiente (05:30, hora de La Meca).",
    "ru": "Уведомления о важных обрядах каждый день с 8 по 13 Зуль-Хиджа: накануне вечером (19:30 по времени Мекки) и утром в день самого обряда (05:30 по времени Мекки).",
    "zh": "每天（8至13日，伊斯兰历十二月）重要功课通知：前一晚（麦加时间19:30）和当天早晨（麦加时间05:30）。",
    "ja": "ズルヒッジャ月8〜13日の各重要儀式の通知：前夜（マッカ時間19:30）と当日の朝（マッカ時間05:30）にお知らせします。",
    "ko": "둘히자 8~13일 매일 중요한 의식 알림: 전날 밤(메카 시간 19:30)과 당일 아침(메카 시간 05:30).",
    "hi": "8–13 ज़ुल-हिज्जा के प्रत्येक दिन के महत्वपूर्ण अनुष्ठानों की सूचनाएँ: पिछली रात (मक्का समय 19:30) और उसी दिन की सुबह (मक्का समय 05:30)।"
  },
  "enable": {
    "id": "Aktifkan pengingat",
    "en": "Enable reminder",
    "ar": "تفعيل التذكير",
    "fr": "Activer le rappel",
    "de": "Erinnerung aktivieren",
    "es": "Activar recordatorio",
    "ru": "Включить напоминание",
    "zh": "启用提醒",
    "ja": "リマインダーを有効にする",
    "ko": "알림 활성화",
    "hi": "अनुस्मारक सक्षम करें"
  },
  "enabled": {
    "id": "Pengingat aktif — {n} notifikasi terjadwal",
    "en": "Reminder active — {n} notifications scheduled",
    "ar": "التذكير مفعَّل — {n} إشعار مجدول",
    "fr": "Rappel actif — {n} notifications programmées",
    "de": "Erinnerung aktiv — {n} Benachrichtigungen geplant",
    "es": "Recordatorio activo — {n} notificaciones programadas",
    "ru": "Напоминание активно — запланировано уведомлений: {n}",
    "zh": "提醒已启用 — 已安排 {n} 条通知",
    "ja": "リマインダー有効 — {n} 件の通知が予定されています",
    "ko": "알림 활성화됨 — {n}개의 알림이 예약됨",
    "hi": "अनुस्मारक सक्रिय — {n} सूचनाएँ निर्धारित हैं"
  },
  "disabled": {
    "id": "Pengingat nonaktif",
    "en": "Reminder inactive",
    "ar": "التذكير غير مفعَّل",
    "fr": "Rappel désactivé",
    "de": "Erinnerung deaktiviert",
    "es": "Recordatorio inactivo",
    "ru": "Напоминание отключено",
    "zh": "提醒已停用",
    "ja": "リマインダー無効",
    "ko": "알림 비활성화됨",
    "hi": "अनुस्मारक निष्क्रिय"
  },
  "todayIs": {
    "id": "Hari ini {date}",
    "en": "Today is {date}",
    "ar": "اليوم هو {date}",
    "fr": "Aujourd'hui, nous sommes le {date}",
    "de": "Heute ist {date}",
    "es": "Hoy es {date}",
    "ru": "Сегодня {date}",
    "zh": "今天是 {date}",
    "ja": "今日は {date} です",
    "ko": "오늘은 {date}입니다",
    "hi": "आज {date} है"
  },
  "hijriMonth": {
    "id": "Dzulhijjah",
    "en": "Dhul Hijjah",
    "ar": "ذو الحجة",
    "fr": "Dhou al-Hijja",
    "de": "Dhul Hijja",
    "es": "Dhul Hijjah",
    "ru": "Зуль-хиджа",
    "zh": "杜勒·海贾月",
    "ja": "ズルヒッジャ月",
    "ko": "줄히자월",
    "hi": "ज़ुल-हिज्जा"
  },
  "hijriMonths": {
    "id": "Muharram|Safar|Rabiul Awal|Rabiul Akhir|Jumadil Awal|Jumadil Akhir|Rajab|Sya'ban|Ramadhan|Syawal|Dzulqa'dah|Dzulhijjah",
    "en": "Muharram|Safar|Rabi al-Awwal|Rabi al-Akhir|Jumada al-Awwal|Jumada al-Akhirah|Rajab|Sha'ban|Ramadan|Shawwal|Dhul Qa'dah|Dhul Hijjah",
    "ar": "محرم|صفر|ربيع الأول|ربيع الآخر|جمادى الأولى|جمادى الآخرة|رجب|شعبان|رمضان|شوال|ذو القعدة|ذو الحجة",
    "fr": "Mouharram|Safar|Rabi al-Awwal|Rabi al-Akhir|Joumada al-Awwal|Joumada al-Akhira|Rajab|Sha'bane|Ramadan|Chawwal|Dhou al-Qi'da|Dhou al-Hijja",
    "de": "Muharram|Safar|Rabi al-Awwal|Rabi al-Akhir|Dschumada al-Awwal|Dschumada al-Achira|Radschab|Scha'ban|Ramadan|Schawwal|Dhul Qa'da|Dhul Hijja",
    "es": "Muharram|Safar|Rabi al-Awwal|Rabi al-Akhir|Jumada al-Awwal|Jumada al-Akhira|Rayab|Sha'ban|Ramadán|Shawwal|Dhul Qa'dah|Dhul Hijjah",
    "ru": "Мухаррам|Сафар|Раби аль-Авваль|Раби аль-Ахир|Джумада аль-Авваль|Джумада аль-Ахира|Раджаб|Ша'бан|Рамадан|Шавваль|Зуль-ка'да|Зуль-хиджа",
    "zh": "穆哈兰姆月|萨法尔月|赖比尔·敖外鲁月|赖比尔·阿色尼月|主马达·敖外鲁月|主马达·阿色尼月|赖哲卜月|舍尔邦月|赖买丹月|闪瓦鲁月|杜尔·盖尔达月|杜勒·海贾月",
    "ja": "ムハッラム|サファル|ラビー・アル＝アウワル|ラビー・アル＝アーヒル|ジュマーダー・アル＝ウーラー|ジュマーダー・アル＝アーヒラ|ラジャブ|シャアバーン|ラマダーン|シャウワール|ズルカアダ|ズルヒッジャ",
    "ko": "무하람|사파르|라비 알-아왈|라비 알-아히르|주마다 알-아왈|주마다 알-아히라|라잡|샤반|라마단|샤왈|줄카다|줄히자",
    "hi": "मुहर्रम|सफ़र|रबी अल-अव्वल|रबी अल-आख़िर|जुमादा अल-अव्वल|जुमादा अल-आख़िरा|रजब|शा'बान|रमज़ान|शव्वाल|ज़ुल-क़ादा|ज़ुल-हिज्जा"
  },
  "hijriSuffix": {
    "id": "H",
    "en": "H",
    "ar": "هـ",
    "fr": "H",
    "de": "H",
    "es": "H",
    "ru": "х.",
    "zh": "回历",
    "ja": "H",
    "ko": "H",
    "hi": "H"
  },
  "correction": {
    "id": "Koreksi tanggal (rukyat)",
    "en": "Date correction (rukyat)",
    "ar": "تصحيح التاريخ (الرؤية)",
    "fr": "Correction de date (rukyat)",
    "de": "Datumskorrektur (Rukyat)",
    "es": "Corrección de fecha (rukyat)",
    "ru": "Коррекция даты (рукьят)",
    "zh": "日期校正（月相观测）",
    "ja": "日付補正（ルキヤット）",
    "ko": "날짜 보정 (루캬트)",
    "hi": "तारीख सुधार (रुकयात)"
  },
  "correctionHint": {
    "id": "Geser ±1 hari bila pengumuman resmi berbeda dari kalender Umm al-Qura.",
    "en": "Shift ±1 day if the official announcement differs from the Umm al-Qura calendar.",
    "ar": "اضبط ±١ يوم إذا اختلف الإعلان الرسمي عن تقويم أم القرى.",
    "fr": "Décalez de ±1 jour si l'annonce officielle diffère du calendrier Umm al-Qura.",
    "de": "Verschieben Sie ±1 Tag, wenn die offizielle Ankündigung vom Umm al-Qura-Kalender abweicht.",
    "es": "Desplace ±1 día si el anuncio oficial difiere del calendario Umm al-Qura.",
    "ru": "Сдвиньте на ±1 день, если официальное объявление отличается от календаря Умм аль-Кура.",
    "zh": "若官方公告与乌姆·古拉历法不符，请调整±1天。",
    "ja": "公式発表がウンム・アル＝クラー暦と異なる場合は±1日調整してください。",
    "ko": "공식 발표가 움 알-쿠라 달력과 다를 경우 ±1일 조정하세요.",
    "hi": "यदि आधिकारिक घोषणा उम्म अल-कुरा कैलेंडर से भिन्न हो तो ±1 दिन समायोजित करें।"
  },
  "upcoming": {
    "id": "Pengingat berikutnya",
    "en": "Next reminder",
    "ar": "التذكير القادم",
    "fr": "Prochain rappel",
    "de": "Nächste Erinnerung",
    "es": "Próximo recordatorio",
    "ru": "Следующее напоминание",
    "zh": "下一个提醒",
    "ja": "次のリマインダー",
    "ko": "다음 알림",
    "hi": "अगला अनुस्मारक"
  },
  "todayTitle": {
    "id": "Hari ini: {title}",
    "en": "Today: {title}",
    "ar": "اليوم: {title}",
    "fr": "Aujourd'hui : {title}",
    "de": "Heute: {title}",
    "es": "Hoy: {title}",
    "ru": "Сегодня: {title}",
    "zh": "今天：{title}",
    "ja": "今日：{title}",
    "ko": "오늘: {title}",
    "hi": "आज: {title}"
  },
  "eveTitle": {
    "id": "Besok: {title}",
    "en": "Tomorrow: {title}",
    "ar": "غداً: {title}",
    "fr": "Demain : {title}",
    "de": "Morgen: {title}",
    "es": "Mañana: {title}",
    "ru": "Завтра: {title}",
    "zh": "明天：{title}",
    "ja": "明日：{title}",
    "ko": "내일: {title}",
    "hi": "कल: {title}"
  },
  "eveBody": {
    "id": "Persiapkan diri malam ini. {body}",
    "en": "Prepare yourself tonight. {body}",
    "ar": "استعدَّ الليلةَ. {body}",
    "fr": "Préparez-vous ce soir. {body}",
    "de": "Bereite dich heute Nacht vor. {body}",
    "es": "Prepárate esta noche. {body}",
    "ru": "Подготовьтесь сегодня вечером. {body}",
    "zh": "今晚做好准备。{body}",
    "ja": "今夜準備をしてください。{body}",
    "ko": "오늘 밤 준비하세요. {body}",
    "hi": "आज रात तैयारी करें। {body}"
  },
  "countdown": {
    "id": "{n} hari menuju Hari Tarwiyah (8 Dzulhijjah)",
    "en": "{n} days until Yawm al-Tarwiyah (8 Dzulhijjah)",
    "ar": "{n} أيام حتى يوم التروية (8 ذو الحجة)",
    "fr": "{n} jours avant le jour al-Tarwiyah (8 Dhul Hijja)",
    "de": "{n} Tage bis zum Yawm al-Tarwiyah (8. Dhul Hijja)",
    "es": "{n} días hasta el día de al-Tarwiyah (8 de Dhul Hijjah)",
    "ru": "{n} дней до дня ат-Тарвии (8 Зуль-Хиджа)",
    "zh": "距塔尔维叶日（载尔黑哲月8日）还有 {n} 天",
    "ja": "ヤウム・アッタルウィーヤ（ズルヒッジャ月8日）まで{n}日",
    "ko": "야움 알-타르위야(즐히자 8일)까지 {n}일 남았습니다",
    "hi": "यौम अल-तरवियह (8 ज़ुलहिज्जा) तक {n} दिन शेष हैं"
  },
  "openTimeline": {
    "id": "Buka Rangkaian Haji",
    "en": "Open Hajj Timeline",
    "ar": "افتح مراحل الحج",
    "fr": "Ouvrir le déroulement du Hajj",
    "de": "Hajj-Ablauf öffnen",
    "es": "Abrir la cronología del Hajj",
    "ru": "Открыть этапы Хаджа",
    "zh": "打开朝觐流程",
    "ja": "ハッジのタイムラインを開く",
    "ko": "하지 일정 열기",
    "hi": "हज का क्रम खोलें"
  },
  "atStation": {
    "id": "Anda berada di sekitar {station} — amalan di sini:",
    "en": "You are near {station} — practices here:",
    "ar": "أنتَ في محيط {station} — الأعمال هنا:",
    "fr": "Vous êtes près de {station} — pratiques ici :",
    "de": "Sie befinden sich in der Nähe von {station} — Praktiken hier:",
    "es": "Estás cerca de {station} — prácticas aquí:",
    "ru": "Вы находитесь рядом с {station} — деяния здесь:",
    "zh": "您正在 {station} 附近——此处的功课：",
    "ja": "あなたは {station} 付近にいます — ここでの実践：",
    "ko": "당신은 {station} 근처에 있습니다 — 이곳의 실천 사항:",
    "hi": "आप {station} के आसपास हैं — यहाँ के अमल:"
  },
  "pushUnavailable": {
    "id": "Notifikasi tidak tersedia di perangkat ini — pengingat tetap tampil di dalam aplikasi.",
    "en": "Notifications are not available on this device — reminders will still appear within the app.",
    "ar": "الإشعارات غير متاحة على هذا الجهاز — ستظل التذكيرات تظهر داخل التطبيق.",
    "fr": "Les notifications ne sont pas disponibles sur cet appareil — les rappels s'afficheront toujours dans l'application.",
    "de": "Benachrichtigungen sind auf diesem Gerät nicht verfügbar — Erinnerungen werden weiterhin in der App angezeigt.",
    "es": "Las notificaciones no están disponibles en este dispositivo — los recordatorios seguirán apareciendo dentro de la aplicación.",
    "ru": "Уведомления недоступны на этом устройстве — напоминания по-прежнему будут отображаться в приложении.",
    "zh": "此设备不支持通知 — 提醒仍将在应用内显示。",
    "ja": "このデバイスでは通知が利用できません — リマインダーは引き続きアプリ内に表示されます。",
    "ko": "이 기기에서는 알림을 사용할 수 없습니다 — 알림은 앱 내에서 계속 표시됩니다.",
    "hi": "इस डिवाइस पर सूचनाएं उपलब्ध नहीं हैं — रिमाइंडर ऐप के भीतर दिखते रहेंगे।"
  },
  "pushEnabledToast": {
    "id": "Pengingat manasik diaktifkan",
    "en": "Manasik reminders enabled",
    "ar": "تم تفعيل تذكيرات المناسك",
    "fr": "Rappels des manasik activés",
    "de": "Manasik-Erinnerungen aktiviert",
    "es": "Recordatorios de manasik activados",
    "ru": "Напоминания о манасик включены",
    "zh": "朝觐功课提醒已启用",
    "ja": "マナーシク（礼拝作法）のリマインダーが有効になりました",
    "ko": "마나식 알림이 활성화되었습니다",
    "hi": "मनासिक रिमाइंडर सक्रिय किए गए"
  },
  "pushDisabledToast": {
    "id": "Pengingat manasik dimatikan",
    "en": "Manasik reminders disabled",
    "ar": "تم إيقاف تذكيرات المناسك",
    "fr": "Rappels des manasik désactivés",
    "de": "Manasik-Erinnerungen deaktiviert",
    "es": "Recordatorios de manasik desactivados",
    "ru": "Напоминания о манасик отключены",
    "zh": "朝觐功课提醒已关闭",
    "ja": "マナーシク（礼拝作法）のリマインダーが無効になりました",
    "ko": "마나식 알림이 비활성화되었습니다",
    "hi": "मनासिक रिमाइंडर निष्क्रिय किए गए"
  },
  "afterHajj": {
    "id": "Rangkaian haji musim ini telah usai — pengingat dijadwalkan untuk musim berikutnya.",
    "en": "This season's Hajj rituals have concluded — reminders are scheduled for the next season.",
    "ar": "انتهت مناسك الحج لهذا الموسم — سيتم جدولة التذكيرات للموسم القادم.",
    "fr": "Les rites du Hajj de cette saison sont terminés — les rappels sont programmés pour la prochaine saison.",
    "de": "Die Hajj-Rituale dieser Saison sind abgeschlossen — Erinnerungen sind für die nächste Saison geplant.",
    "es": "Los rituales del Hajj de esta temporada han concluido — los recordatorios están programados para la próxima temporada.",
    "ru": "Ритуалы Хаджа этого сезона завершены — напоминания запланированы на следующий сезон.",
    "zh": "本季朝觐仪式已结束 — 提醒已为下一季安排好。",
    "ja": "今シーズンのハッジの儀式が終了しました — 次のシーズンのリマインダーが設定されています。",
    "ko": "이번 시즌의 하즈 의식이 마무리되었습니다 — 다음 시즌을 위한 알림이 예약되었습니다.",
    "hi": "इस सत्र के हज के मनासिक समाप्त हो गए — रिमाइंडर अगले सत्र के लिए निर्धारित किए गए हैं।"
  },
  "eveningLabel": {
    "id": "Malam sebelumnya",
    "en": "The evening before",
    "ar": "مساء اليوم السابق",
    "fr": "La veille au soir",
    "de": "Der Vorabend",
    "es": "La noche anterior",
    "ru": "Накануне вечером",
    "zh": "前一天晚上",
    "ja": "前夜",
    "ko": "전날 저녁",
    "hi": "पिछली शाम"
  },
  "morningLabel": {
    "id": "Pagi hari-H",
    "en": "The morning of the day",
    "ar": "صباح يوم الحدث",
    "fr": "Le matin du jour J",
    "de": "Der Morgen des Tages",
    "es": "La mañana del día señalado",
    "ru": "Утро дня проведения",
    "zh": "当天早上",
    "ja": "当日の朝",
    "ko": "당일 아침",
    "hi": "उस दिन की सुबह"
  },
  "share": {
    "id": "Bagikan",
    "en": "Share",
    "ar": "مشاركة",
    "fr": "Partager",
    "de": "Teilen",
    "es": "Compartir",
    "ru": "Поделиться",
    "zh": "分享",
    "ja": "シェア",
    "ko": "공유",
    "hi": "साझा करें"
  },
  "shareDay": {
    "id": "Bagikan kartu hari ini",
    "en": "Share today's card",
    "ar": "مشاركة بطاقة اليوم",
    "fr": "Partager la carte du jour",
    "de": "Heutige Karte teilen",
    "es": "Compartir la tarjeta de hoy",
    "ru": "Поделиться карточкой дня",
    "zh": "分享今天的卡片",
    "ja": "今日のカードをシェア",
    "ko": "오늘의 카드 공유",
    "hi": "आज का कार्ड साझा करें"
  },
  "shareText": {
    "id": "{date} — {title}. Mohon doakan kami dari Tanah Suci 🕋",
    "en": "{date} — {title}. Please pray for us from the Holy Land 🕋",
    "ar": "{date} — {title}. الرجاء الدعاء لنا من الأراضي المقدسة 🕋",
    "fr": "{date} — {title}. Veuillez prier pour nous depuis la Terre Sainte 🕋",
    "de": "{date} — {title}. Bitte betet für uns aus dem Heiligen Land 🕋",
    "es": "{date} — {title}. Por favor, oren por nosotros desde la Tierra Santa 🕋",
    "ru": "{date} — {title}. Пожалуйста, помолитесь за нас со Святой Земли 🕋",
    "zh": "{date} — {title}。请为我们在圣地祈祷 🕋",
    "ja": "{date} — {title}。聖地から私たちのためにお祈りください 🕋",
    "ko": "{date} — {title}. 성지에서 저희를 위해 기도해 주세요 🕋",
    "hi": "{date} — {title}. कृपया पवित्र भूमि से हमारे लिए दुआ करें 🕋"
  },
  "shareDua": {
    "id": "Doa hari ini",
    "en": "Today's du'a",
    "ar": "دعاء اليوم",
    "fr": "Du'a du jour",
    "de": "Heutiges Du'a",
    "es": "Du'a de hoy",
    "ru": "Ду'а дня",
    "zh": "今日杜阿",
    "ja": "今日のドゥアー",
    "ko": "오늘의 두아",
    "hi": "आज की दुआ"
  },
  "shareBy": {
    "id": "Dibagikan oleh {name}",
    "en": "Shared by {name}",
    "ar": "شاركه {name}",
    "fr": "Partagé par {name}",
    "de": "Geteilt von {name}",
    "es": "Compartido por {name}",
    "ru": "Поделился(-лась) {name}",
    "zh": "由 {name} 分享",
    "ja": "{name} がシェア",
    "ko": "{name} 님이 공유",
    "hi": "{name} द्वारा साझा किया गया"
  },
  "shareReady": {
    "id": "Kartu siap dibagikan",
    "en": "Card ready to share",
    "ar": "البطاقة جاهزة للمشاركة",
    "fr": "Carte prête à être partagée",
    "de": "Karte bereit zum Teilen",
    "es": "Tarjeta lista para compartir",
    "ru": "Карточка готова к отправке",
    "zh": "卡片已准备好分享",
    "ja": "カードのシェア準備ができました",
    "ko": "카드 공유 준비 완료",
    "hi": "कार्ड साझा करने के लिए तैयार है"
  },
  "shareFail": {
    "id": "Gagal membuat kartu. Coba lagi.",
    "en": "Failed to create card. Please try again.",
    "ar": "فشل إنشاء البطاقة. يرجى المحاولة مرة أخرى.",
    "fr": "Échec de la création de la carte. Veuillez réessayer.",
    "de": "Karte konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
    "es": "Error al crear la tarjeta. Por favor, inténtelo de nuevo.",
    "ru": "Не удалось создать карточку. Пожалуйста, попробуйте ещё раз.",
    "zh": "创建卡片失败，请重试。",
    "ja": "カードの作成に失敗しました。もう一度お試しください。",
    "ko": "카드 생성에 실패했습니다. 다시 시도해 주세요.",
    "hi": "कार्ड बनाने में विफल रहा। कृपया पुनः प्रयास करें।"
  },
  "dayLabel": {
    "id": "Hari ke-{n} · {title}",
    "en": "Day {n} · {title}",
    "ar": "اليوم {n} · {title}",
    "fr": "Jour {n} · {title}",
    "de": "Tag {n} · {title}",
    "es": "Día {n} · {title}",
    "ru": "День {n} · {title}",
    "zh": "第{n}天 · {title}",
    "ja": "{n}日目 · {title}",
    "ko": "{n}일차 · {title}",
    "hi": "दिन {n} · {title}"
  }
};
